<template>
  <div
    data-qa="criterion-dictionary">
    <div
      v-for="(elem, n) in items"
      :key="elem.id || elem.key"
      class="flex align-start gap-5"
      data-qa="dictionary-item">
      <sFormItem
        :error="nameValidate(elem, elem.title)"
        :label="$t('Tenders.Variant') + ' ' + ( + n + 1)"
        required
        :show-message="!!nameValidate(elem, elem.title)">
        <sInput
          data-qa="dictionary-item-title"
          max-length="245"
          :value.sync="elem.title"/>
      </sFormItem>
      <sFormItem
        :label="$t('Tenders.Weight')">
        <sInputNumber
          data-qa="dictionary-item-score"
          :minus="true"
          :value.sync="elem.score"/>
      </sFormItem>
      <sButton
        class="mt-6 mb-auto"
        data-qa="delete-dictionary-item"
        icon="delete"
        small
        type="green"
        @click="$emit('deleteListItem', elem)"/>
    </div>
    <sButton
      class="h11-links-bold px-2"
      data-qa="add-dictionary-item"
      icon="plus"
      icon-size="10px"
      small
      type="text"
      @click="$emit('addListItem')">
      {{ $t('Tenders.AddOption') }}
    </sButton>
  </div>
</template>
<script>

import { modalMixin } from 'mixins'

export default {
  name: 'typeVariants',
  mixins: [ modalMixin ],
  props: {
    item: Object,
    card: Object,
    items: Array
  },
  methods: {
    nameValidate(item, title) {
      if (!title?.trim()) {
        return this.$t('Validate.Required')
      }
      if (title && this.$_.countBy(this.items, 'title' )[title] > 1 ) {
        return this.$t('Tenders.NameIsInUse')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.text-input {
  max-width:  200px;
}
</style>
